import ModalDrawer from "../../../../../common/components/organisme/ModalDrawer/ModalDrawer";
import AddNewConnectorFormView from "./AddNewConnectorFormView/AddNewConnectorFormView";
import {
  BConnector,
  BConnectorPatch,
  ConnectorType,
} from "../../../types/stations.types";
import { useEffect, useState } from "react";
import inputValidityChecker from "../../../../../utils/inputValidityChecker";
import { useAuth } from "../../../../auth/hooks";
import { userRoles } from "../../../../user/types/user.types";
import ErrorScreenApp from "../../../../errorHandler/components/ErrorScreenApp/ErrorScreenApp";

import useConnectors, { useSingleConnector } from "../../../hooks/useConnectors";
import { extractAxoisErrorsMessage } from "../../../../errorHandler/utils/errors.utils";

import useQueryURL from "../../../../../common/hooks/useQueryURL";
import { LoaderSreen } from "../../../../../common/components/molecule/Loader/Loader";

import useNavigationApp from "../../../../../navigation/useNavigationApp";


export interface ConnectorDataForm {

  tag?: string;
  type?: ConnectorType;
  organizationId?: string;
  chargePointId?: string;
  currency?: string;
  pricePerKwh?: number;
  maxPowerKW?: number;
  slug?: string;
  tagId?: string;
}

export interface ConnectorDataFormErrorState {

  isErrorTag: boolean;
  isErrorType: boolean;
  isErrorOrganizationId?: boolean;
  isErrorChargePointId?: boolean;
  isErrorCurrency?: boolean;
  isErrorPricePerKwh?: boolean;
  allGood?: boolean;
  messageError?: string;
  isErrorSlug?: boolean;
  isErrorTagId?: boolean;
  isErrorMaxPowerKW?: boolean;

}

export interface AddNewConnectorFormProps {
  onSuccess?: (data: BConnector) => void;
  chargePointId?: string;
  isUpdate?: boolean;
  connectorIdToUpdate?: string;
}

const INITIAL_FORM_DATA: ConnectorDataForm = {

  tag: "",
  organizationId: "",
};

const INITIAL_ERROR_STATE: ConnectorDataFormErrorState = {

  isErrorTag: false,
  isErrorType: false,
  isErrorChargePointId: false,
  isErrorOrganizationId: false,
  allGood: true,
  messageError: undefined,
  isErrorMaxPowerKW: false,
};

const tradAxiosErrorMessages = (message: string): ConnectorDataFormErrorState=> {
  const error = { ...INITIAL_ERROR_STATE, allGood: true };

  const messageList = [];
  
    messageList.push(message);
  

  

  error.messageError = messageList.join(", ").concat(".");
  return error;

}

/**
 * AddNewConnectorFormPresenter
 *
 * @param param0
 * @returns
 */
export default function AddNewConnectorFormPresenter({
  onSuccess,
  chargePointId,
  isUpdate,
  connectorIdToUpdate
}: AddNewConnectorFormProps) {

  
  const [form, setFormData] = useState<ConnectorDataForm>({
    ...INITIAL_FORM_DATA,
  });
  const [errorMessage, setErrorMessage] = useState<string | undefined | null>(
    undefined
  );
  const [errorState, setErrorState] = useState<ConnectorDataFormErrorState>({
    ...INITIAL_ERROR_STATE,
  });

  const [isLoading, setIsLoading] = useState<boolean>(false);

  const { userRole, organizationIdUser } = useAuth();
  const { createNewConnectorQuery: sendForm, chargePointIdFound } = useConnectors({
    chargePointId: chargePointId,
  });

  const {getSingleConnectorQuery, patchSingleConnectorQuery } = useSingleConnector({connectorId: connectorIdToUpdate, chargePoint: chargePointId});


  const navigationApp = useNavigationApp();


  useEffect(() => {
    if (isUpdate && getSingleConnectorQuery.data) {
      const data = getSingleConnectorQuery.data;
      setFormData({
        type: data.b_connector_type,
        organizationId: data.b_connector_organization_id,
        chargePointId: data.b_connector_charge_point,
        currency: data.b_connector_price_currency,
        pricePerKwh: data.b_connector_price_per_kwh,
        slug: data.b_connector_slug,
        tagId: String(data.b_connector_tag_id),
        maxPowerKW: data.b_connector_max_power_kw,
      });
    }
  }, [isUpdate, getSingleConnectorQuery.data]); // eslint-disable-line

  if (!userRole) {
    return (
      <ErrorScreenApp
        message="Aucun utilisateur connectée, veuillez vous connecter svp."
        title="Opps, Accès non-authorisé"
      />
    );
  }

  const checkValidity = (
    data: BConnectorPatch
  ): ConnectorDataFormErrorState => {
    const errorState: ConnectorDataFormErrorState = {
      ...INITIAL_ERROR_STATE,
    };

    const messageList = [];



    if (!inputValidityChecker.validateNotEmptyText(data.b_connector_type)) {
      errorState.allGood = false;
      errorState.isErrorType = true;
      messageList.push("Type est obligatoire");
    }
    if(!inputValidityChecker.validateNotEmptyText(data.b_connector_price_currency)){
      errorState.isErrorCurrency = true;
      errorState.allGood = false;
      messageList.push("La devise est obligatoire");
    }

    if(!inputValidityChecker.validateNotEmptyText(data.b_connector_charge_point)){
      errorState.isErrorChargePointId = true;
      errorState.allGood = false;
      messageList.push("Charge Point ID est obligatoire");
    }

    if ( !data.b_connector_tag_id || !inputValidityChecker.validateNumberInt(data.b_connector_tag_id.toString()) || data.b_connector_tag_id === 0) {
      errorState.isErrorTagId = true;
      errorState.allGood = false;
      messageList.push("Tag ID est obligatoire");
    }

    if (
      userRole < userRoles.SUPER_ADMIN &&
      !inputValidityChecker.validateNotEmptyText(
        data.b_connector_organization_id
      )
    ) {
      errorState.isErrorOrganizationId = true;
      errorState.allGood = false;
      messageList.push("Organization ID est obligatoire");
    }


  

    if (messageList.length > 0) {
      errorState.messageError = messageList.join(", ").concat(".");
    }

    if (data.b_connector_max_power_kw && data.b_connector_max_power_kw < 0) {
      errorState.isErrorMaxPowerKW = true;
      errorState.allGood = false;
      messageList.push("La puissance maximale doit être supérieure à 0");
    }
  

    return errorState;
  };

  const converteForm = (data: ConnectorDataForm): BConnectorPatch => {
    return {
      b_connector_type: data.type,
      b_connector_organization_id: data.organizationId || organizationIdUser || "",
      b_connector_charge_point: data.chargePointId ||chargePointIdFound  || "",
      b_connector_price_currency: data.currency || "",
      b_connector_price_per_kwh: data.pricePerKwh !== undefined ? Number(data.pricePerKwh) : 0,
      b_connector_slug: data.slug || "",
      b_connector_tag_id: data.tagId !== undefined ? Number(data.tagId) : 0,
      b_connector_max_power_kw: data.maxPowerKW !== undefined ? Number(data.maxPowerKW) : 0,
    };
  };

  const handleSetDataForm = (key: keyof ConnectorDataForm, value: string) => {
    setFormData((prev) => {
      return {
        ...prev,
        [key]: value,
      };
    });
  };

  const handleSubmit = async () => {
    const newConnector = converteForm(form);
    const error = checkValidity(newConnector);
    setIsLoading(true);


    setIsLoading(false);

    if (error.allGood) {


      if (isUpdate) {
        patchSingleConnectorQuery.mutate({
          data: newConnector,
          callback: ({ result, error }) => {
            if (error) {
              const errorMessage = extractAxoisErrorsMessage(error);
              const errorState = tradAxiosErrorMessages(errorMessage);
              setErrorState(errorState);
              setErrorMessage(errorState.messageError);
            }
            if (result) {
              onSuccess && onSuccess(result as BConnector);
              navigationApp.goToSingleConnector(
                result.station_id,
                result.b_connector_charge_point,
                result.b_connector_id,
              )
            }
          },
        });

      }else{

      sendForm.mutate({
        newData: newConnector,
        callback: ({ result, error }) => {
          if (error) {
            const errorMessage = extractAxoisErrorsMessage(error);
            const errorState =tradAxiosErrorMessages(errorMessage);
            setErrorState(errorState)
            setErrorMessage(errorState.messageError);
          }
          if (result) {
            onSuccess && onSuccess(result as BConnector);
          }
        },
      });
    }

    } else {
      setErrorState(error);
      setErrorMessage(error.messageError);
    }
  };


  if (sendForm.isLoading || getSingleConnectorQuery.isLoading) {
    return <LoaderSreen heigth={"100px"} />;
  }



  return (
    <AddNewConnectorFormView
      isLoading={sendForm.isLoading || isLoading ||  patchSingleConnectorQuery.isLoading}
      setFormData={handleSetDataForm}
      formData={form}
      errorStatus={errorState}
      messageError={errorMessage}
      handleSubmit={handleSubmit}
      currentUserRoleCreator={userRole}
      isUpdate={isUpdate}
      submitLabel={isUpdate ? "Modifier" : "Ajouter"}
      description={isUpdate ? "Modifier les informations du connecteur" : "Saisissez les informations du nouveau connecteur"}
      title={isUpdate ? "Modifier le connecteur" : "Ajouter un connecteur"}
      
    />
  );
}

export function AddNewConnectorFormModal({
  modaleId = "new-connector-modal",
  chargepointId,
}: {
  modaleId: string;
  chargepointId?: string;
  stationId?: string;
}) {
  const { removeQueryValue } = useQueryURL();

  const handleSuccess = (data: BConnector) => {
    removeQueryValue([modaleId]);
  };

  return (
    <ModalDrawer urlParamName={modaleId} title="Nouveau connecteur">
      <AddNewConnectorFormPresenter
        onSuccess={handleSuccess}
        chargePointId={chargepointId}
      />
    </ModalDrawer>
  );
}
